import getConstructorType from './getConstructorType';

export default function(x, toString) {
  // 空白處理
  if(x === '') x = "0";
	// 非文字則轉為文字
  if(getConstructorType(x) !== 'string') x = x.toString();
  // 拆分小數點左側與右側
  const parts = x.split(".");
  // 左側移除千分位
  parts[0]=parts[0].replace(/,/g,'');
  if(toString) {
    return parts.join(".");
  } else {
    // 合併並轉為數字回傳
	  return parseFloat(parts.join("."));
  }
};


// WEBPACK FOOTER //
// ./src/commonJS/removeCommasToNumber.js